import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import * as Preact from 'preact';
import * as SelectedBadge from './A_SelectedBadge';

export interface Props {
    id: string;
    image: string;
    selected: boolean;
    loading: boolean;
    disabled: boolean;
    onClick?: () => void;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '73px',
                height: '78px',
            }}
        >
            <Box
                onClick={!p.loading && !p.disabled ? p.onClick : undefined}
                sx={{
                    width: '73px',
                    height: '78px',
                    borderRadius: '8px',
                    outline: p.selected ? '1px solid black' : 'none',
                    background: `no-repeat center url('${p.image}')`,
                    backgroundSize: 'contain',
                    backgroundColor: '#FFFFFF',
                    opacity: p.disabled || p.loading ? '50%' : '100%',
                    position: 'relative',
                    cursor: p.disabled ? 'default' : 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {p.selected && <SelectedBadge.Component sx={{ top: '4px', right: '4px' }} />}
            </Box>
            {p.loading && (
                <CircularProgress
                    sx={{
                        position: 'absolute',
                    }}
                />
            )}
        </Box>
    );
};

Component.displayName = 'ProductImageSmall';
